module.exports = __webpack_public_path__ + "img/negar.0b124db0.jpeg";